export const title = 'Disponibilidad';
export const subTitle =
  'Selecciona las casillas del calendario para activar ventas en los días de apertura del parque.';
export const buttonText = 'Actualizar';
export const closeDayModal = 'Estas seguro que quieres cerrar el día?';
export const aviaryTimetableTitleModal = 'Configurador de horario de aviario';
export const aviaryTimeTableColStartDate = 'Hora comienzo';
export const aviaryTimeTableColEndDate = 'Hora término';
export const aviaryTimeTableColSelected = 'Estado';
